(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('FbQuestionWrapperService', FbSelectService);

    function FbSelectService(lodash) {
        return {
            showTextbox: function (vm) {
                var textSetting = vm.element.options.settings.showText || null;
                if (vm.model.answer == null) {
                    return false;
                }

                var result = false;
                switch (textSetting.operator) {
                    case "eq":
                        result = (textSetting.value == lodash.get(vm, 'model.answer', null));
                        break;
                    case "notEq":
                        result = (textSetting.value != lodash.get(vm, 'model.answer', null));
                        break;
                    case "in":
                        if (['multichoice'].indexOf(vm.element.type) >= 0) {
                            result = false;
                            var ansArr = lodash.get(vm, 'model.answer', []);
                            for (var i in ansArr) {
                                var _ans = ansArr[i];
                                if (textSetting.value.indexOf(_ans) >= 0) {
                                    result = true;
                                    break;
                                }
                            }

                        } else {
                            result = (textSetting.value.indexOf(parseInt(lodash.get(vm, 'model.answer', -1))) != -1);
                        }
                        break;
                }
                return result;

            },
            onBlur: function(vm, target) {
                if (!lodash.has(vm.model,'others') || lodash.get(vm.model,'others','').length == 0) {
                    angular.element(target).parent().addClass('error');
                    angular.element(target).parent().find('.error-message').remove();
                    angular.element(target).after('<span class="error-message">Additional details are required.</span>');
                } else {
                    angular.element(target).parent().removeClass('error');
                    angular.element(target).parent().find('.error-message').remove();
                }
            },
            onChange: function(vm) {
                if(lodash.get(vm.model, 'others')){ 
                    const model = {
                        answer: vm.model.answer
                    };
                    lodash.set(vm, 'model', model);
                }
                return vm;
            }
        }
    }
})();